<!-- Wrapper -->
<div fuseGlassGlow="ocean" class="flex w-full flex-auto flex-col">
  <!-- Content -->
  <div class="flex flex-auto flex-col">
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>
</div>
